import styled from 'styled-components';

import { FormInput, FormSelect, units } from '@calm-web/design-system';

export const Input = styled(FormInput)`
	margin-bottom: ${units(3)};
`;

export const StyledFormSelect = styled(FormSelect)`
	margin-bottom: ${units(3)};
`;
